import React, { useEffect, useState } from 'react'
import { Tag } from 'antd'
import {
  getPaymentAssignmentStatusLabel,
  PaymentAssignmentStatusId,
  PaymentType,
  Priority,
  PAYMENT_TYPE_LABELS,
  PRIORITY_LABELS,
} from '../Utils/types'
import {
  getPaymentTypeTagColor,
  getPriorityTagColor,
  getPaymentStatusColor,
  TAG_COLORS,
} from '../payment-assignment.style'
import { ActiveFiltersRow } from './styles'
import type { FilterUpdateFn } from './types'

interface PaymentAssignmentFilterActiveTagsProps {
  statusesValue: string[]
  paymentTypesValue: (string | PaymentType)[]
  priorityLevelsValue: Priority[]
  updateFilter: FilterUpdateFn
  onSearch: () => void
}

export default function PaymentAssignmentFilterActiveTags({
  statusesValue,
  paymentTypesValue,
  priorityLevelsValue,
  updateFilter,
  onSearch,
}: PaymentAssignmentFilterActiveTagsProps) {
  const [refreshKey, setRefreshKey] = useState(false)
  useEffect(() => {
    if (refreshKey) {
      onSearch()
      setRefreshKey(false)
    }
  }, [refreshKey])

  const hasAny =
    statusesValue.length > 0 ||
    paymentTypesValue.length > 0 ||
    priorityLevelsValue.length > 0

  if (!hasAny) return null

  return (
    <ActiveFiltersRow>
      {statusesValue.map((status) => (
        <Tag
          key={`status-${status}`}
          closable
          onClose={() => {
            updateFilter(
              'statuses',
              statusesValue.filter((s) => s !== status)
            )
            setRefreshKey(true)
          }}
          color={getPaymentStatusColor(status as PaymentAssignmentStatusId)}
        >
          {getPaymentAssignmentStatusLabel(status)}
        </Tag>
      ))}
      {paymentTypesValue.map((type) => (
        <Tag
          key={`type-${type}`}
          closable
          onClose={() => {
            updateFilter(
              'paymentTypes',
              paymentTypesValue.filter((t) => t !== type) as PaymentType[]
            )
            setRefreshKey(true)
          }}
          color={getPaymentTypeTagColor(type)}
        >
          {PAYMENT_TYPE_LABELS[type] ?? type}
        </Tag>
      ))}
      {priorityLevelsValue.map((priority) => (
        <Tag
          key={`priority-${priority}`}
          closable
          onClose={() => {
            updateFilter(
              'priorityLevels',
              priorityLevelsValue.filter((p) => p !== priority)
            )
            setRefreshKey(true)
          }}
          color={getPriorityTagColor(priority) || TAG_COLORS.default}
        >
          {PRIORITY_LABELS[priority] ?? String(priority)}
        </Tag>
      ))}
    </ActiveFiltersRow>
  )
}
